import {OskBuySubscriptionFormComponent} from '../osk-buy-subscription-form/osk-buy-subscription-form.component';
import {MyOskSubscriptionsService} from '../../../../api/api-services/my-osk-subscriptions.service';
import {IInitialisedPaymentLinkVm} from '../../../../api/initialised-payment-link-vm.model';
import {centerDynamicModalConfig} from '../../../shared/helpers/modal.config';
import {DialogService, DynamicDialogRef} from 'primeng/dynamicdialog';
import {eModalRoles} from '../../../shared/models/modals';
import {Component, inject} from '@angular/core';
import {PlatformAvailableSubscriptionPlansService} from "../../../../api/api-services/platform-available-subscription-plans.service";
import {IPlatformSubscriptionPlanVm} from "../../../../api/platform-subscription-plan-vm.model";
import { PlatformAvailableSubscriptionPlansForOskService } from '../../../../api/api-services/platform-available-subscription-plans-for-osk.service';
@Component({
  selector: 'app-osk-subscription-list',
  templateUrl: './osk-subscription-list.component.html',
  styleUrl: './osk-subscription-list.component.scss'
})
export class OskSubscriptionListComponent {
  private _platformAvailableSubscriptionPlansForOskService = inject(PlatformAvailableSubscriptionPlansForOskService);
  private _myOskSubscriptionsService = inject(MyOskSubscriptionsService);
  private _primengDialogService = inject(DialogService);

  public activeIndex: number = 0;
  public loading: boolean = false;

  private ref: DynamicDialogRef | undefined;


  goToBuySubscriptionsModal(selectedSubscriptionGuid: string | null): void {
    this.loading = true; // Show a loading indicator or disable button while loading
    this._platformAvailableSubscriptionPlansForOskService.get("pl").subscribe(
      {
        next: (data: IPlatformSubscriptionPlanVm[]) => {
          this.loading = false;
          this.openBuySubscriptionModal(selectedSubscriptionGuid, data)
          if (data.length > 0) {
            this.openBuySubscriptionModal(selectedSubscriptionGuid, data)
          } else {
            console.error('Subscriptions are not available');
          }
        },
        error: (err) => {
          this.loading = false;
          console.error('Error fetching subscriptions data:', err);
        }
      }
    );
  }

  openBuySubscriptionModal(selectedSubscriptionGuid: string | null, subscriptionPlans: IPlatformSubscriptionPlanVm[]) {
    this.ref = this._primengDialogService.open(OskBuySubscriptionFormComponent, {
      ...centerDynamicModalConfig,
      data: {
        subscriptionPlans,
        selectedSubscriptionGuid
      }
    });

    this.ref.onClose.subscribe((res: {
      status: eModalRoles,
      link: IInitialisedPaymentLinkVm | null
    }) => {
      if (res.status === eModalRoles.SUCCESS) {
        if (res.link?.sessionUrl) {
          window.open(res.link?.sessionUrl, '_self')
        }
      }
    })
  }


  ngOnDestroy(): void {
    if (this.ref) {
      this.ref.close(); // Closes the dialog if it's still open
      this.ref = undefined;
    }
  }
}
